<template>
  <v-layout>
    <v-list-item-group style="width:100%">
      <v-dialog ref="newPhoneNumberDlg"
                v-model="showNewPhoneNumber"
                :return-value.sync="selected"
                max-width="500px">
        <template v-slot:activator="{ on }">
          <v-autocomplete :items="addressesPlus"
                          v-model="selected"
                          :disabled="disabled"
                          :item-text="formatPhoneNumber"
                          :item-value="indexOfAddress"
                          :readonly="addressesPlus.length == 1"
                          @change="$event < 0 && on.click()"
                          @click="addressesPlus.length == 1 && on.click()">
            <template v-slot:item="data">
              <v-icon v-if="data.item.icon" class="mr-2">{{data.item.icon}}</v-icon>
              <v-list-item-content>
                {{formatPhoneNumber(data.item)}}
              </v-list-item-content>
            </template>
            <template v-slot:prepend-inner>
              <v-icon v-if="selectedIcon" @click="on.click()">{{selectedIcon}}</v-icon>
            </template>
          </v-autocomplete>
          </template>
        <v-card>
          <v-toolbar dense dark flat color="primary">
            <v-icon dark class="mr-2">phone</v-icon>
            <v-toolbar-title>{{newNumberDlgTitle}}</v-toolbar-title>
          </v-toolbar>
          <v-alert class="mx-4 mt-2" v-if="errorMsg" type="error">
            {{errorMsg}}
          </v-alert>
          <v-tabs-items v-model="newNumberDlgMode" :touchless="true">
            <v-tab-item>
              <v-form v-model="newNumberValid">
                <v-layout column pa-4>
                  <v-flex class="pb-4">
                    <vue-phone-number-input ref="phoneInput"
                                            v-model="newNumber"
                                            color="secondary"
                                            size="lg"
                                            clearable
                                            valid-color="secondary"
                                            required></vue-phone-number-input>
                  </v-flex>
                  <v-layout>
                    <v-btn text color="error" @click="closeDialog">Cancel</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn type="submit" 
                           @click.prevent="addNumber" 
                           :disabled="!newNumberValid" 
                           color="primary"
                           :loading="loadingNewNumberApiResponse">Add number</v-btn>
                  </v-layout>
                </v-layout>
              </v-form>
            </v-tab-item>
            <v-tab-item>
              <code-verifier :to="$refs.phoneInput && $refs.phoneInput.phoneNumber || 'your number'"
                             :sends="objectToPost"
                             @error="setError"
                             @done="closeDialog"
                             @loading="setLoading"></code-verifier>
            </v-tab-item>
          </v-tabs-items>         
        </v-card>
        </v-dialog>
    </v-list-item-group>
  </v-layout>

</template>

<script>
  import axios from '../plugins/axios';
  import { parsePhoneNumberFromString } from 'libphonenumber-js'

  export default {
    props: [
      'addresses',
      'disabled',
      'value',
      'type'
    ],
    components: {
      VuePhoneNumberInput: () => import('vue-phone-number-input'),
      CodeVerifier: () => import('./CodeVerifier'),
    },
    data: () => ({
      parsePhoneNumberFromString,
      showNewPhoneNumber: false,
      newNumber: '',
      newNumberDlgMode: 0,
      loadingNewNumberApiResponse: false,     
      errorMsg: '',
    }),
    computed: {
      user() {
        return this.$store.state.user;
      },
      passengerId() {
        return this.$store.state.passengerId;
      },
      addressesPlus() {
        return this.addresses.concat({
          address: 'New number',
          icon: 'add_circle_outline'
        })
      },
      selected: {
        get() { return this.value; },
        set(v) { this.$emit('input', v); }
      },
      selectedIcon() {
        return this.addressesPlus.slice(this.selected)[0].icon
      },
      newNumberValid: {
        get() { return this.newNumber && this.$refs.phoneInput && this.$refs.phoneInput.isValid; },
        set(v) { }
      },
      newNumberDlgTitle() {
        switch (this.newNumberDlgMode) {
          case 1: return "Verify your phone number";
          default: return "Add a phone number";
        }
      }, 
      objectToPost() {
        return {
          ContactMethodId: this.type.contactMethodId,
          PassengerId: this.passengerId,
          Address: this.newNumber &&
            this.$refs.phoneInput &&
            this.$refs.phoneInput.phoneFormatted &&
            this.$refs.phoneInput.phoneFormatted.replace(/[^+0-9]/ig, '')
        }
      }
    },
    methods: {
      indexOfAddress(addr) {
        return this.addresses.length ? this.addresses.indexOf(addr) : 0;
      },
      formatPhoneNumber(addr) {
        return addr.contactAddressId ? this.parsePhoneNumberFromString(addr.address).formatNational() : addr.address
      },
      log() {
        console.log(...arguments);
      },
      closeDialog() {
        this.$refs.newPhoneNumberDlg.save(0);
        this.showNewPhoneNumber = false;
        this.errorMsg = '';
        this.newNumberDlgMode = 0;
      },
      addNumber() {
        this.loadingNewNumberApiResponse = true;
        axios.post('api/VerifyAddress/' + this.user.cnxUserId, this.objectToPost).then((res) => {
          this.newNumberDlgMode = 1;
          this.errorMsg = '';
        }).catch((err) => {
          this.errorMsg = '';
          if (err.response) {
            if (err.response.status == 409) this.errorMsg = 'You can already send notifications to that phone number!'
            else if (err.response.status == 401) this.errorMsg = 'You dont seem to be logged in - please refresh the page and log in again'
            else if (err.response.data && err.response.data.Message) {
              switch (err.response.data.Message) {
                case "Supplied address is unreachable":
                  this.errorMsg = 'We couldn\'t send a code to that number. Please enter a different one';
                  break;
              }
            }
          }
          if (this.errorMsg == '') {
            this.errorMsg = 'Something went wrong. Please try refreshing the page and try again';
            console.log(err);
          }
        }).finally(() => {
          this.loadingNewNumberApiResponse = false;
        });
      },
      setError(m) {
        this.errorMsg = m;
      },
      setLoading(l) {
        this.loadingNewNumberApiResponse = l;
      }
    },
    mounted() {
      this.$refs.newPhoneNumberDlg.$refs.dialog.style.overflowY = "visible"
    }
  };
</script>
